import { gql } from '@apollo/client';

// Serie di potenza del giorno per fascia oraria, aggregata dal database
// (funzione SQL measure_power_series_today). Restituisce ~16 righe per impianto
// invece di tutte le misure grezze di oggi.
const getPowerSeriesQuery = gql`
    query getPowerSeries($plantIds: _int4!) {
        powerSeries: measure_power_series_today(args: { plant_ids: $plantIds }) {
            plantId: plant_id
            hour
            power
        }
    }
`;

export default getPowerSeriesQuery;
